"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedopenletter = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 54",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedopenletter` : '') + (description ? ` desc-brandedopenletter` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedopenletter"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedopenletter"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 24h56v26a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V24Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.4 2.23 0 24h56L30.6 2.23a4 4 0 0 0-5.2 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "white",
    d: "M6 8h44v30H6z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.23 11.61c0-2-1.62-3.6-3.62-3.6h-.93A105.8 105.8 0 0 1 5 44.07v.95c0 1.97 1.6 3.58 3.57 3.6h26.6l15.07-12.6V11.6v.01Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 14.2h32",
    stroke: "#E90B5A",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 18.7h32",
    stroke: "#E90B5A",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 23.2h32",
    stroke: "#E90B5A",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 27.7h32",
    stroke: "#E90B5A",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34 34 0 24v26a4 4 0 0 0 4 4c.33 0 30-20 30-20Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m22 34 34-10v26a4 4 0 0 1-4 4c-.33 0-30-20-30-20Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.65 33.71.5 52.01s.78 1.09 1.5 1.5c.7.38 2 .5 2 .5h48s1.3-.12 2-.5c.72-.41 1.5-1.5 1.5-1.5L30.35 33.7a4 4 0 0 0-4.7 0Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedopenletter;